import api from "./api";
import { config } from "./config.service";

const API_URL = config.host_api;

export const medicalInsurancePostdocUpload = async (data) => {
  api.post(API_URL + "medical-insurance", data);
};

export const getMedicalInsurancePostdoc = async (mip_id) => {
  return api
    .get(API_URL + `medical-insurance/${mip_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getMedicalInsurancePostdocMentor = async (mentor_id) => {
  return api
    .get(API_URL + `medical-insurance/mentor/${mentor_id}`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const getMedicalInsurancePostdocAdmin = async () => {
  return api
    .get(API_URL + `medical-insurance/admin`)
    .then((res) => {
      if (res.data) return res.data;
    })
    .catch((err) => err);
};

export const updateMedicalInsurance = (mip_id, status) => {
  return api.put(`${API_URL}medical-insurance/${mip_id}/${status}`);
};
